import { render, staticRenderFns } from "./TableButtonsCopyObjectsGeometryDialog.vue?vue&type=template&id=5914f92a&scoped=true&"
import script from "./TableButtonsCopyObjectsGeometryDialog.vue?vue&type=script&lang=js&"
export * from "./TableButtonsCopyObjectsGeometryDialog.vue?vue&type=script&lang=js&"
import style0 from "./TableButtonsCopyObjectsGeometryDialog.vue?vue&type=style&index=0&id=5914f92a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914f92a",
  null
  
)

export default component.exports